export default __webpack_public_path__ + "static/media/anexar.ae4a58b6.svg";